module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av522-9b4b6945e399927182591c7c8652dd11.jpg";